module.exports = __webpack_public_path__ + "img/carousel-3.5cd106e5.png";